<template>
  <div class="container contactenos">
    <div class="container section text-center py-3">
      <h2>Formulario de contacto</h2>
      <div class="form-group py-1">
        <div class="col text-left">
          <label for="motivoSelect">Motivo</label>
        </div>
        <select class="form-control" id="motivoSelect">
          <option>Hacer un reclamo</option>
          <option>Hacer un pedido</option>
          <option>Información general</option>
          <option>Sugerencia</option>
          <option>Vacantes</option>
        </select>
      </div>
      <div class="form-group py-1">
        <div class="col text-left">
          <label for="nombreApellido">Nombre y apellidos</label>
        </div>
        <input
          id="nombreApellido"
          class="form-control"
          type="text"
          placeholder="Nombre y apellidos"
        />
      </div>
      <div class="form-group py-1">
        <div class="col text-left">
          <label for="telefono">Teléfono</label>
        </div>
        <input
          id="telefono"
          class="form-control"
          type="text"
          placeholder="Telefono"
        />
      </div>
      <div class="form-group py-1">
        <div class="col text-left">
          <label for="correo">Correo electrónico</label>
        </div>
        <input
          type="email"
          class="form-control"
          id="correo"
          placeholder="nombre@ejemplo.com"
        />
      </div>
      <div class="form-group py-4">
        <div class="col text-left">
          <label for="mensajeTextArea">Mensaje</label>
        </div>
        <textarea
          class="form-control"
          placeholder="Escriba aqui su mensaje"
          id="mensajeTextArea"
          rows="5"
        ></textarea>
      </div>
      <div class="col">
        <button class="btn btn-danger btn-round">Enviar</button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "contacto",
};
</script>
<style>
.contactenos {
  min-height: calc(100vh - 300px);
}
</style>
